module.exports = __webpack_public_path__ + "img/wallet.83c43ef9.png";